import type { ModuleMigrationDef } from "@kubdee/sdk";
import type { CapabilityName } from "../capabilities";

// Issue #249 M7: typed constant — a typo becomes a compile error.
const CAPABILITIES = JSON.stringify(["messaging"] satisfies CapabilityName[]);

/**
 * Seed the `facebook-messenger` connector type row.
 *
 * - Idempotent via `INSERT OR IGNORE`: re-running the migration after P5b /
 *   follow-ups won't overwrite operator edits to the row (e.g. scope
 *   changes, icon swaps).
 * - Primary key `id` is set equal to `slug` so the capability registry can
 *   register under the SAME string the webhook ingress route uses —
 *   `connector_instances.type_id` ends up matching the slug too, which keeps
 *   the adapter lookup uniform across webhook and `call()` paths.
 * - `oauth_config` carries enough to drive `token-refresh` jobs from P2's
 *   scheduler DO (`scheduler.do.ts → dispatchTokenRefresh` expects
 *   `{ tokenUrl, clientId, clientSecret? }`). We reference env-var names
 *   rather than hard-coding credentials so the row is safe to ship in a
 *   public migration.
 * - `webhook_config` records which header + algorithm the adapter expects —
 *   useful for dashboards / debugging; the adapter itself hard-codes the
 *   same values in `webhook.ts`.
 * - `created_at` / `updated_at` use a fixed seed timestamp — tenants-local
 *   time isn't available at seed time, and the column is audit-only.
 */
export const migration: ModuleMigrationDef = {
  key: "002_facebook_messenger_seed",
  version: "0.2.0",
  sql: `
INSERT OR IGNORE INTO \`connectors_types\` (
  id, slug, name, icon, icon_url, capabilities, oauth_config, webhook_config,
  is_active, created_at, updated_at
) VALUES (
  'facebook-messenger',
  'facebook-messenger',
  'Facebook Messenger',
  'MessageCircle',
  NULL,
  '${CAPABILITIES}',
  '{"tokenUrl":"https://graph.facebook.com/v25.0/oauth/access_token","clientIdEnv":"FACEBOOK_MESSENGER_CLIENT_ID","clientSecretEnv":"FACEBOOK_MESSENGER_CLIENT_SECRET","authorizeUrl":"https://www.facebook.com/v25.0/dialog/oauth","scopes":["pages_messaging","pages_show_list","pages_manage_metadata","pages_read_engagement"],"configIdEnv":"FACEBOOK_MESSENGER_CONFIG_ID"}',
  '{"signatureHeader":"x-hub-signature-256","algorithm":"HMAC-SHA256","secretEnv":"FB_APP_SECRET"}',
  1,
  '2026-04-17T00:00:00Z',
  '2026-04-17T00:00:00Z'
);
  `.trim(),
};
